// extracted by mini-css-extract-plugin
export default {"gazeEyeContainer":"GazeEye_gazeEyeContainer__Uh1GN","gazeEye":"GazeEye_gazeEye__f1bLW","gazeEyeBorder":"GazeEye_gazeEyeBorder__oovzt"};